import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import { BackToTopFloatButton, Footer, Header, Preloader, WhatsappFloatButton } from './components';

type MainLayoutProps = {
	homeComponent?: React.ElementType;
	children: React.ReactNode;
};

const MainLayout = ({ homeComponent, children }: MainLayoutProps) => {
	const HomeComponent = homeComponent as React.ElementType;
	// TODO: Implement global loading state change on route transitions to remove local loading state.
	// This approach helps prevent flickering when pages load for the first time.
	const [localIsLoading, setLocalIsLoading] = useState(true);
	const globalIsLoading = useSelector((state: RootState) => state.pageLoader.isLoading);

	useEffect(() => {
		const timer = setTimeout(() => setLocalIsLoading(false), 1000);
		return () => clearTimeout(timer);
	}, []);

	// Combine local and global loading states
	const shouldShowPreloader = localIsLoading || globalIsLoading;

	return (
		<Container fluid>
			{homeComponent && <HomeComponent />}
			<Header />
			{children}
			<Footer />
			<Preloader show={shouldShowPreloader} />
			<BackToTopFloatButton />
			<WhatsappFloatButton />
		</Container>
	);
};

export default MainLayout;
